import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import ItemDiscountLabel from './ItemDiscountLabel';

var ItemDiscount = function ItemDiscount(_ref) {
  var discount = _ref.discount;

  if (!discount) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ItemDiscountLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "commerce.adsBanner.getDiscount.title",
    values: {
      discount: /*#__PURE__*/React.createElement(FormattedNumber, {
        value: discount,
        style: "percent" // eslint-disable-line react/style-prop-object
        ,
        maximumFractionDigits: 0
      })
    }
  }));
};

ItemDiscount.defaultProps = {
  discount: null
};
export default ItemDiscount;